/**
 * TeamSystem Impact - My M&A Deals Hook
 *
 * Dice se l'utente corrente è autorizzato ad almeno un fascicolo M&A. La voce
 * di menù compare solo in quel caso: chi non ha deal non deve nemmeno sapere
 * che il modulo esiste. Se la fetch fallisce, nessun deal — non crasha.
 */

import { useState, useEffect } from 'react';
import { maApi, DealSummary } from './api';

export interface MyDeals {
  deals: DealSummary[];
  hasDeals: boolean;
  loading: boolean;
  /** true se la chiamata è fallita: "lista vuota" e "non ho potuto chiedere"
   *  sono due cose diverse, e la pagina deve poterle distinguere. */
  failed: boolean;
}

export function useMyDeals(): MyDeals {
  const [deals, setDeals] = useState<DealSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setFailed(false);

    maApi
      .fetchMyDeals()
      .then((result) => {
        if (!cancelled) setDeals(result);
      })
      .catch(() => {
        // La voce di menù resta comunque nascosta: in caso di dubbio, meno
        // superficie. La pagina però lo dice all'utente.
        if (!cancelled) setFailed(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { deals, hasDeals: deals.length > 0, loading, failed };
}
